module.exports = __webpack_public_path__ + "static/media/chango.f5775444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/servicios/compra-online/chango.png
// module id = 409
// module chunks = 0